'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dotPropImmutable = require('dot-prop-immutable');

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _reference = require('../../constants/reducers/reference');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    references: {}
};

function referenceReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _reference.REDUCE_REFERENCES:
            return _dotPropImmutable2.default.set(state, 'references.' + action.payload.code, action.payload.value);
        default:
            return state;
    }
}

exports.default = referenceReducer;